import React from "react";
import { BaseFragAnnouncerPack } from "./BaseFragAnnouncerPack";
import { MessageAnimationContext } from "../../../../client/components/MultiPlayer/messageAnimations";
import KitKitMiauMiauAnimation from "../../../../client/components/MultiPlayer/animations/KitKitMiauMiauAnimation";
import catTrack from "./kit-kit-miau-miau/track.mp3";

export default class KitKitMiauMiauFragAnnouncerPack extends BaseFragAnnouncerPack {
  getAudio(eventType: string): string | null {
    return eventType === "frag" ? catTrack : null;
  }

  protected getVictimHandler(
    context: MessageAnimationContext
  ): React.ReactElement {
    // Resolve fragger name
    let fraggerName = "Unknown";
    if (context.message.type === "frag") {
      for (const [, player] of context.gameState.players.entries()) {
        if (player.numPlayer === context.message.fraggerNumPlayer) {
          fraggerName = player.name || "Unknown";
          break;
        }
      }
    }

    return (
      <KitKitMiauMiauAnimation
        {...context}
        analysisTrackUrl={catTrack}
        fraggerName={fraggerName}
      />
    );
  }
}

